"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZOOM_HEIGHT = exports.ZOOM_WIDTH = exports.CSS = void 0;
var image_button_1 = require("../../components/button/image.button");
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-CollectionEdit',
    isMissing: 'c-CollectionEdit--is-missing',
    isLoading: 'c-CollectionEdit--is-loading',
    isEmpty: 'c-CollectionEdit--empty',
    leftIcon: 'c-CollectionEdit__Icon',
    title: {
        container: 'c-CollectionEditTitle',
        tools: 'c-CollectionEditTitle__Tools',
        save: 'c-CollectionEditTitle__Save',
        discard: 'c-CollectionEditTitle__Discard',
        title: 'c-CollectionEditTitle__Text',
        form: 'c-CollectionEditTitle__Form',
        isInvalid: 'c-CollectionEditTitle--invalid'
    },
    zoom: 'c-CollectionEditTitle__Zoom',
    field: {
        container: 'c-CollectionField',
        summary: 'c-CollectionField__Summary',
        detail: 'c-CollectionField__Detail',
        title: 'c-CollectionField__Title',
        value: 'c-CollectionField__Value',
        isImageUpload: 'c-CollectionFiled__ImageUpload',
        colorIndicator: 'c-CollectionField__ColorIndicator'
    },
    form: {
        container: 'c-SubForm',
        header: 'c-SubForm__Header',
        title: 'c-SubForm__Title',
        tools: 'c-SubForm__Tools',
        footer: 'c-SubForm__Footer',
        footerButton: 'c-SubForm__FooterButton',
        titleName: 'c-SubForm__TitleName',
        titleCount: 'c-SubForm__TitleCount',
        actions: 'c-SubForm__Actions',
        isRoot: 'c-SubForm--is-root'
    },
    instance: {
        container: 'c-SubFormInstance',
        header: 'c-SubFormInstance__Header',
        icon: 'c-SubFormInstance_Icon',
        title: 'c-SubFormInstance_Title',
        tools: 'c-SubFormInstance___Tools',
        text: 'c-SubFormInstance_Text',
        isOpen: 'c-SubFormInstance--is-open'
    }
};
exports.ZOOM_WIDTH = '460px';
exports.ZOOM_HEIGHT = '200px';
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.container] = {
        'background-color': theme_1.DefaultTheme.background.offWhite,
        'white-space': 'nowrap',
        'font-family': theme_1.DefaultTheme.font.familyCondensed,
        display: 'flex',
        'flex-direction': 'column',
        width: '100%',
        height: '100%',
        'max-height': '100%',
        'border-left': '1px solid ' + theme_1.DefaultTheme.font.color.divider,
        'border-right': '1px solid ' + theme_1.DefaultTheme.font.color.divider
    },
    _a[exports.CSS.isMissing] = {
        'align-items': 'center',
        'justify-content': 'center'
    },
    _a[exports.CSS.isLoading] = {
        'align-items': 'center',
        'justify-content': 'center'
    },
    _a[exports.CSS.title.container] = {
        display: 'flex',
        'background-color': theme_1.DefaultTheme.background.lightGrey,
        'align-items': 'center',
        'justify-content': 'space-between',
        padding: '4px',
        height: theme_1.DefaultTheme.space(6),
        'min-height': theme_1.DefaultTheme.space(6),
        'line-height': theme_1.DefaultTheme.space(6),
        'border-bottom': "1px solid ".concat(theme_1.DefaultTheme.font.color.divider)
    },
    _a[exports.CSS.title.save] = {
        color: theme_1.DefaultTheme.color.accent
    },
    _a[exports.CSS.title.title] = {
        'text-transform': 'inherit',
        'font-weight': 'inherit',
        'font-family': 'inherit'
    },
    _a[exports.CSS.zoom] = {
        height: exports.ZOOM_HEIGHT,
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'flex-shrink': 0,
        'background-color': theme_1.DefaultTheme.background.lightGrey,
        'box-shadow': theme_1.DefaultTheme.shadow.box.bottom
    },
    _a[exports.CSS.field.title] = {
        flex: '1 0 30%',
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis'
    },
    _a[exports.CSS.field.value] = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: theme_1.DefaultTheme.font.color.supporting,
        overflow: 'hidden',
        width: '100%',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis'
    },
    _a[exports.CSS.field.isImageUpload] = {
        display: 'flex',
        'justify-content': 'space-between',
        'align-items': 'center',
        height: '20px',
        width: '20px',
        'min-width': '20px',
        'margin-left': theme_1.DefaultTheme.space(1),
        'margin-right': theme_1.DefaultTheme.space(1)
    },
    _a[exports.CSS.field.colorIndicator] = {
        height: theme_1.DefaultTheme.space(3),
        width: theme_1.DefaultTheme.space(3),
        borderRadius: '50%',
        marginRight: '38px'
    },
    _a[exports.CSS.field.container] = {
        padding: '4px ' + theme_1.DefaultTheme.space(2)
    },
    _a[exports.CSS.field.summary] = (_b = {
            display: 'flex',
            'justify-content': 'space-between',
            'align-items': 'center'
        },
        _b["& .".concat(image_button_1.CSS.container)] = {
            height: '20px',
            width: '20px',
            'min-width': '20px',
            'margin-left': theme_1.DefaultTheme.space(1)
        },
        _b),
    _a[exports.CSS.field.detail] = {
        'margin-top': theme_1.DefaultTheme.space(1),
        'border-left': '2px solid ' + theme_1.DefaultTheme.font.color.divider,
        display: 'flex',
        'flex-direction': 'column',
        'align-items': 'center'
    },
    _a[exports.CSS.form.container] = {
        padding: '8px 0px 4px 0'
    },
    _a[exports.CSS.form.isRoot] = {
        'overflow-x': 'hidden',
        'overflow-y': 'auto'
    },
    _a[exports.CSS.form.header] = (_c = {
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'space-between',
            padding: "0 ".concat(theme_1.DefaultTheme.space(2))
        },
        _c["& .".concat(exports.CSS.form.tools)] = {
            display: 'none'
        },
        _c["&:hover .".concat(exports.CSS.form.tools)] = {
            display: 'flex'
        },
        _c),
    _a[exports.CSS.form.title] = {
        'font-weight': 'bold',
        display: 'flex'
    },
    _a[exports.CSS.form.tools] = (_d = {},
        _d["& .".concat(image_button_1.CSS.container)] = {
            height: '20px',
            width: '20px',
            'min-width': '20px',
            'padding-left': theme_1.DefaultTheme.space(1)
        },
        _d),
    _a[exports.CSS.form.footer] = {
        'margin-left': theme_1.DefaultTheme.space(2),
        display: 'flex',
        'justify-content': 'space-between'
    },
    _a[exports.CSS.form.footerButton] = {
        display: 'flex',
        'align-items': 'center',
        'margin-right': theme_1.DefaultTheme.space(2),
        'font-weight': 'normal',
        'text-transform': 'none',
        'font-family': theme_1.DefaultTheme.font.familyCondensed,
        color: theme_1.DefaultTheme.font.color.supporting,
        '&:hover': {
            color: theme_1.DefaultTheme.font.color.primary
        },
        '& i': {
            'padding-right': theme_1.DefaultTheme.space(1)
        }
    },
    _a[exports.CSS.form.titleCount] = {
        'margin-left': theme_1.DefaultTheme.space(1),
        color: theme_1.DefaultTheme.color.accent
    },
    _a[exports.CSS.instance.container] = {
        'margin-left': theme_1.DefaultTheme.space(2)
    },
    _a[exports.CSS.instance.header] = (_e = {
            display: 'flex',
            'background-color': theme_1.DefaultTheme.background.lightGrey,
            'align-items': 'center',
            'justify-content': 'space-between',
            padding: "".concat(theme_1.DefaultTheme.space(2), " 0 ").concat(theme_1.DefaultTheme.space(2), " ").concat(theme_1.DefaultTheme.space(2)),
            height: theme_1.DefaultTheme.space(6),
            'line-height': theme_1.DefaultTheme.space(6),
            cursor: 'pointer',
            'border-left': '2px solid ' + theme_1.DefaultTheme.background.lightGrey,
            '&:hover': {
                'background-color': theme_1.DefaultTheme.background.grey,
                'border-left': '2px solid ' + theme_1.DefaultTheme.color.accent
            }
        },
        _e["& .".concat(exports.CSS.instance.tools)] = {
            display: 'none'
        },
        _e["&:hover .".concat(exports.CSS.instance.tools)] = {
            display: 'flex'
        },
        _e),
    _a[exports.CSS.instance.icon] = {
        width: theme_1.DefaultTheme.space(8),
        position: 'absolute',
        left: '-36px'
    },
    _a[exports.CSS.instance.isOpen] = {
        'margin-top': '12px',
        'margin-bottom': '8px',
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2
    },
    _a[exports.CSS.instance.title] = {
        display: 'flex',
        'align-items': 'center',
        position: 'relative'
    },
    _a[exports.CSS.instance.text] = {
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis'
    },
    _a[exports.CSS.isEmpty] = {
        color: theme_1.DefaultTheme.font.color.disabled
    },
    _a["".concat(exports.CSS.isEmpty, " ").concat(exports.CSS.form.header)] = {
        padding: 0
    },
    _a));
//# sourceMappingURL=collection.view.style.js.map